import React from 'react';
import { Box, Heading, Text, Button, VStack, HStack, Icon, Badge } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FiAlertTriangle, FiShoppingBag, FiArrowLeft, FiHelpCircle } from 'react-icons/fi';

const PaymentFailed = () => {
  const navigate = useNavigate();

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center" 
      minHeight="80vh"
      p={6}
      bg="#F8FAFC"
    >
      <VStack 
        spacing={6} 
        maxW="480px" 
        w="full"
        bg="white" 
        p={{ base: 6, md: 8 }} 
        borderRadius="2xl" 
        boxShadow="sm" 
        border="1px solid"
        borderColor="gray.100"
        textAlign="center"
      >
        <Box 
          w="72px" 
          h="72px" 
          borderRadius="full" 
          bg="red.50" 
          color="red.500" 
          display="flex" 
          alignItems="center" 
          justifyContent="center"
          boxShadow="0 0 0 10px rgba(239, 68, 68, 0.08)"
        >
          <Icon as={FiAlertTriangle} boxSize={8} />
        </Box>

        <Box>
          <Badge
            bg="red.50"
            color="red.600"
            px={3}
            py={0.5}
            borderRadius="full"
            fontSize="xs"
            fontWeight="bold"
            textTransform="uppercase"
            mb={2}
          >
            Transaction Interrupted
          </Badge>
          <Heading size="md" color="#162237">
            Payment Not Completed
          </Heading>
          <Text color="gray.600" fontSize="sm" mt={2} lineHeight="tall">
            Your transaction was either declined by your bank or cancelled before completion. No funds have been deducted from your account.
          </Text>
        </Box>

        <VStack w="100%" spacing={3} pt={2}>
          <Button 
            w="100%" 
            size="lg" 
            bg="#162237" 
            color="white" 
            leftIcon={<FiShoppingBag />}
            _hover={{ bg: "#0B132B", transform: 'translateY(-1px)' }}
            onClick={() => navigate('/cart')}
          >
            Return to Cart & Retry Payment
          </Button>

          <Button 
            w="100%" 
            variant="outline" 
            borderColor="gray.200"
            size="md" 
            leftIcon={<FiArrowLeft />}
            _hover={{ bg: "gray.50" }}
            onClick={() => navigate('/')}
          >
            Back to Store Home
          </Button>
        </VStack>

        <HStack spacing={2} color="gray.400" fontSize="xs" pt={2}>
          <Icon as={FiHelpCircle} />
          <Text>
            Need help? Reach our accounts concierge at <strong>support@navneetlaw.com</strong>
          </Text>
        </HStack>
      </VStack>
    </Box>
  );
};

export default PaymentFailed;